// WorkspaceRedirect.tsx — shown when a visitor lands on a subdomain that
// resolves to the app but isn't a real workspace (the `tenants/resolve` lookup
// 404s). Wave D owner decision: a quiet one-line redirect — wordmark, spinner,
// one sentence — instead of the old gradient splash with its fake progress bar.
import { useEffect } from 'react';
import { Logo } from '@/foundation/primitives';
import { ONBOARDING_URL } from './AuthShell';

const DELAY_MS = 2200;

export default function WorkspaceRedirect({ subdomain }: { subdomain: string }) {
  useEffect(() => {
    const t = setTimeout(() => window.location.replace(ONBOARDING_URL), DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={page}>
      <main style={column}>
        <div style={brandRow}>
          <Logo size={22} />
          <div style={spinner} aria-hidden="true" />
        </div>
        <h1 style={h1}>
          <strong>{subdomain}</strong> isn’t a PharmacyIQ workspace.
        </h1>
        <p className="caption" style={{ margin: 0 }}>
          Taking you to mypharmacyiq.com to get started…{' '}
          <a href={ONBOARDING_URL} style={link}>
            Go now →
          </a>
        </p>
      </main>
    </div>
  );
}

const page: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  background: 'var(--bg-app)',
  padding: 'clamp(40px, 14vh, 140px) var(--space-5) var(--space-5)',
};

const column: React.CSSProperties = { width: '100%', maxWidth: 400 };

const brandRow: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 'var(--space-3)',
  marginBottom: 'var(--space-5)',
};

const spinner: React.CSSProperties = {
  width: 16,
  height: 16,
  borderRadius: '50%',
  border: '2px solid var(--primary-lighter)',
  borderTopColor: 'var(--primary-main)',
  animation: 'piqSpin 1s linear infinite',
};

const h1: React.CSSProperties = {
  margin: '0 0 6px',
  fontSize: 'var(--fs-display)',
  fontWeight: 400,
  lineHeight: '28px',
  color: 'var(--text-primary)',
};

const link: React.CSSProperties = {
  color: 'var(--primary-ink)',
  fontWeight: 700,
  textDecoration: 'none',
};
